import { z } from "zod";

import type { Schema as EntitySchema } from "./schema";

const zSchema = z.enum(["name", "description"] as const satisfies (keyof EntitySchema)[]);
type Schema = z.infer<typeof zSchema>;

export { zSchema };
export type { Schema };
